import React, { useState } from 'react';
import {
  Input as AntInput, InputNumber, Checkbox,
} from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { Input, Rule } from '../../../../store/modules/rules';
import InputSelect from './InputSelect';
import getRuleFieldValue from './utils/getRuleFieldValue';
import TextareaEditModal from './textarea.edit.modal';

interface IStmtInputProps {
  rule: Rule;
  input: Input;
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input) => void;
  containerDirection: string;
  contentDirection: string;
}

const number = (
  rule: Rule,
  input: Input,
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input) => void,
) => (
  <InputNumber
    value={getRuleFieldValue<number>(rule, input.name)}
    onChange={(value: number | null) => {
      onChange(value, rule, input);
    }}
  />
);
const string = (
  rule: Rule,
  input: Input,
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input) => void,
) => (
  <div>
    <AntInput
      value={getRuleFieldValue<string>(rule, input.name)}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value, rule, input);
      }}
    />
  </div>
);
const select = (
  rule: Rule,
  input: Input,
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input) => void,
) => (
  <InputSelect rule={rule} input={input} onChange={onChange} />
);

const textarea = (
  rule: Rule,
  input: Input,
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input) => void,
) => {
  // eslint-disable-next-line
  const [editText, setEditText] = useState<string>('');
  // eslint-disable-next-line
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <div>
      {modalVisible && (
        <TextareaEditModal
          value={editText}
          visible={modalVisible}
          onCancel={() => setModalVisible(false)}
          onConfirm={(code: string, language: string) => {
            const v = `#!${language}\n${code}`;
            onChange(v, rule, input);
            setModalVisible(false);
          }}
        />
      )}
      <AntInput.TextArea
        value={getRuleFieldValue<string>(rule, input.name)}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
          onChange(e.target.value, rule, input);
        }}
        // autoSize
        onDoubleClick={() => {
          setEditText(getRuleFieldValue<string>(rule, input.name) || '');
          setModalVisible(true);
        }}
      />
      <span>(Double click the textarea to open source code editor)</span>
    </div>
  );
};
const boolean = (
  rule: Rule,
  input: Input,
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input) => void,
) => (
  <Checkbox
    value={getRuleFieldValue<boolean>(rule, input.name)}
    onChange={(e: CheckboxChangeEvent) => {
      onChange(e.target.checked, rule, input);
    }}
  />
);

const TYPE_TO_COMPONENT: {
  [key: string]: ((
    rule: Rule,
    input: Input,
    onChange: (value: string, rule: Rule, input: Input) => void
  ) => JSX.Element | null)
} = {
  number,
  string,
  select,
  textarea,
  boolean,
};

const StatementInput = ({
  rule, input, onChange, contentDirection, containerDirection,
}: IStmtInputProps): JSX.Element => {
  const renderer = TYPE_TO_COMPONENT[input.type];
  // eslint-disable-next-line
  const styles: any = {
    paddingLeft: '5px', paddingRight: '5px',
  };

  if (containerDirection === 'column' && contentDirection === 'row') {
    styles.width = '180px';
    styles.textOverflow = 'ellipsis';
  }

  return (
    <div style={{ display: 'flex', flexDirection: contentDirection as 'row' | 'column' }}>
      {input.label && (
        <div style={styles}>
          {input.label}
          :
          {' '}
        </div>
      )}
      {renderer ? renderer(rule, input, onChange) : (
        <div style={{ paddingLeft: '5px' }}>
          `$
          {input.type}
          ` type not supported
        </div>
      )}
    </div>
  );
};

export default StatementInput;
